import type { AnimationEvent } from "@angular/animations";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import type { AfterViewInit } from "@angular/core";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconComponent } from "@optee/ui/components/icon/icon.component";
import { NAV_ITEMS } from "../navigation-items";

@Component({
  selector: "swc-you-are-menu",
  host: {
    class:
      "m-auto rounded-2xl p-8 max-xl:hidden bg-white shadow-o flex flex-col gap-4",
  },
  animations: [
    trigger("animation", [
      state(
        "hidden",
        style({
          opacity: 0,
          transform: "scale(0.8)",
        }),
      ),
      state(
        "visible",
        style({
          opacity: 1,
          transform: "scale(1)",
        }),
      ),
      transition("hidden <=> visible", animate("0.15s ease-in-out")),
    ]),
  ],
  template: `
    @for (item of routes; track item.label) {
      <a
        class="group flex items-center gap-4 text-sm font-semibold"
        [routerLink]="item.url"
      >
        <!-- @todo Update hover effect when Optee icons lib is ready (was bg and not border that was animated) -->
        <oui-icon
          class="group-hover:border-primary-500 text-primary-500 bg-primary-200 size-10 rounded-md border-0 p-2 group-hover:border group-hover:text-white"
          [svg]="'bicolor/' + item.icon"
        />
        <h4
          class="text-primary-800 group-hover:text-primary-500 flex items-center text-sm font-semibold"
        >
          {{ item.label }}
        </h4>
      </a>
    }
  `,
  imports: [RouterModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YouAreMenuComponent implements AfterViewInit {
  @Output() closed = new EventEmitter<void>();

  @HostBinding("@animation") animationState = "hidden";

  @HostListener("@animation.done", ["$event"]) done(event: AnimationEvent) {
    if (event.toState === "hidden") {
      this.closed.emit();
    }
  }

  // Source: https://briantree.se/angular-cdk-overlay-tutorial-adding-animations
  ngAfterViewInit() {
    this.animationState = "visible";
  }

  close() {
    this.animationState = "hidden";
  }

  // YOUR_ARE_ITEMS = YOUR_ARE_ITEMS;
  routes = NAV_ITEMS[0]?.routes ?? [];
}
